export const getCurrentRoute = (state) => {
  return state;
};
